export enum TiposBeneficiosReforma {
  BAC = 'BAC',
  PGU = 'PGU',
  UF_RETIRO_PROGRAMADO = 'UF_RETIRO_PROGRAMADO',
  CEV = 'CEV'
}

export enum TitulosBeneficiosReforma {
  BAC = 'Beneficio por Años Cotizados (BAC)',
  PGU = 'Aumento de la Pensión Garantizada Universal (PGU)',
  UF_RETIRO_PROGRAMADO = 'Ajuste de pensión en 2 UF',
  CEV = 'Compensación por Diferencia de Expectativa de Vida'
}